import React from 'react';
import { GameBrand } from '@precisionpros/game-ui';

export default function BuildProBrand({ size = 'login', markOnly = false, className = '' }) {
  return <GameBrand game={{ name: 'Build', wordmarkMain: 'Build', wordmarkAccent: 'Pro', badge: 'B', accent: '#0f766e' }} size={size} markOnly={markOnly} className={className} />;
}
